const FrequentCustomerContentLoader = () => {
  return (
    <div className="p-5 w-full bg-white rounded-lg shadow-[0px_0px_8px_rgba(166,166,166,0.25)]">
      <div className="space-y-1">
        <div className="w-36 h-4 bg-light_gray rounded-sm animate-pulse"></div>
        <div className="h-7 bg-light_gray rounded-sm animate-pulse"></div>
      </div>
    </div>
  );
};

export default FrequentCustomerContentLoader;
